import { render, staticRenderFns } from "./CommunitiesNavbar.vue?vue&type=template&id=6561ae37&scoped=true&"
import script from "./CommunitiesNavbar.vue?vue&type=script&lang=js&"
export * from "./CommunitiesNavbar.vue?vue&type=script&lang=js&"
import style0 from "./CommunitiesNavbar.vue?vue&type=style&index=0&id=6561ae37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561ae37",
  null
  
)

export default component.exports